import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--xw-ink)] text-white xw-noise"
    >
      <div className="xw-container relative z-10 pt-14 md:pt-20 pb-8 md:pb-10">
        {/* massive type CTA */}
        <div className="border-b border-white/15 pb-10 md:pb-16">
          <span className="font-mono-xw text-[11px] tracking-[0.22em] uppercase text-[var(--xw-orange)]">
            // Outside Operations. Inside Confidence.
          </span>
          <h3
            className="mt-5 md:mt-6 font-display font-black uppercase tracking-[-0.03em] leading-[0.85]"
            style={{ fontSize: "clamp(3.5rem, 12vw, 9rem)" }}
          >
            Let's <span className="italic font-medium" style={{ color: "var(--xw-orange)" }}>Talk.</span>
          </h3>
          <a
            href="#contact"
            data-testid="footer-cta-contact"
            className="mt-8 inline-flex items-center gap-2 px-5 py-3 bg-white text-[var(--xw-ink)] font-semibold border border-white hover:bg-[var(--xw-orange)] hover:text-white hover:border-[var(--xw-orange)] transition-colors rounded-[2px]"
          >
            Request a Discovery Call
            <ArrowUpRight size={16} />
          </a>
        </div>

        {/* Bottom rows */}
        <div className="grid grid-cols-12 gap-6 md:gap-8 pt-10 md:pt-12">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-2">
              <span
                className="inline-flex items-center justify-center w-7 h-7 rounded-[2px]"
                style={{ background: "var(--xw-orange)", color: "#fff" }}
              >
                <span className="font-display font-black text-lg leading-none">
                  X
                </span>
              </span>
              <span className="font-display font-black uppercase tracking-tight text-[17px]">
                Xterior<span className="text-[var(--xw-orange)]">/</span>Works
              </span>
            </div>
            <p className="mt-5 text-white/60 max-w-md leading-relaxed text-[14px]">
              An exterior operations company managing carts, lots, grounds and
              everything customers see and touch before walking through your
              door.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="font-mono-xw text-[10px] tracking-[0.22em] uppercase text-white/40 mb-4">
              Sections
            </div>
            <ul className="space-y-2 text-[14px]">
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="#why">The Problem</a></li>
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="#services">Services</a></li>
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="#who">Who We Serve</a></li>
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="#process">Process</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="font-mono-xw text-[10px] tracking-[0.22em] uppercase text-white/40 mb-4">
              Company
            </div>
            <ul className="space-y-2 text-[14px]">
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="#contact">Contact</a></li>
              <li><a className="hover:text-[var(--xw-orange)] transition-colors" href="/admin" data-testid="footer-admin-link">Admin</a></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="font-mono-xw text-[10px] tracking-[0.22em] uppercase text-white/40 mb-4">
              Service Region
            </div>
            <p className="text-[14px] text-white/70 leading-relaxed">
              Northeast Ohio HQ <br />
              Expanding regionally — inquiries welcome from all markets.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/40 font-mono-xw text-[11px] tracking-[0.18em] uppercase">
          <div>© {year} Xterior Works LLC — All rights reserved.</div>
          <div>Field Doc / v.001 / Built for Operators</div>
        </div>
      </div>
    </footer>
  );
}
